import React from 'react'
import { Button } from '../../../atoms'
import { RichTextEditor } from '../../RichTextEditor'
import { NoteAIAssistant } from '../../NoteAIAssistant'
import {
  NoteEditor,
  EditorHeader,
  EditorTitle,
  EditorHint,
  EditorActions,
} from './NoteEditorForm.styles'
import type { NoteEditorFormProps } from './NoteEditorForm.types'

export const NoteEditorForm: React.FC<NoteEditorFormProps> = ({
  content,
  onChange,
  onSave,
  onCancel,
  title,
  hint,
  saveLabel = 'Save',
  cancelLabel = 'Cancel',
  placeholder = 'Start typing your note...',
  minHeight = 120,
  aiRecordingProps,
}) => {
  return (
    <NoteEditor>
      {(title || hint) && (
        <EditorHeader>
          {title && <EditorTitle>{title}</EditorTitle>}
          {hint && <EditorHint>{hint}</EditorHint>}
        </EditorHeader>
      )}
      {aiRecordingProps && (
        <NoteAIAssistant
          onComplete={aiRecordingProps.onComplete}
          onError={aiRecordingProps.onError}
          onReset={aiRecordingProps.onReset}
          isAnalyzing={aiRecordingProps.isAnalyzing}
          analyzingText={aiRecordingProps.translations?.analyzing}
          processingText={aiRecordingProps.translations?.processing}
          errorText={aiRecordingProps.translations?.error}
          translations={aiRecordingProps.translations}
        />
      )}
      <RichTextEditor
        value={content}
        onChange={onChange}
        placeholder={placeholder}
        minHeight={minHeight}
      />
      <EditorActions>
        <Button variant="secondary" size="small" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button variant="primary" size="small" onClick={onSave}>
          {saveLabel}
        </Button>
      </EditorActions>
    </NoteEditor>
  )
}
